<template>
  <div class="grid w-full grid-cols-4 gap-4">
    <form-input
      v-model="localValue.street"
      class="col-span-2"
      :auto-focus="true"
      :show-error="false"
      name="street"
      placeholder="Straatnaam"
      label="Straatnaam"
      rules="required|capitalized"
    ></form-input>
    <form-input v-model="localValue.number" name="number" :show-error="false" placeholder="Huisnummer" label="Huisnummer" rules="required"></form-input>
    <form-input v-model="localValue.additional" name="additional" :show-error="false" placeholder="Toevoeging" label="Toevoeging"></form-input>
    <form-input v-model="localValue.zip" class="col-span-2" :show-error="false" name="zip" placeholder="Postcode" label="Postcode" rules="required"></form-input>
    <form-input v-model="localValue.city" class="col-span-2" :show-error="false" name="city" placeholder="Gemeente" label="Gemeente" rules="required|capitalized"></form-input>
    <country-select
      placeholder="Selecteer land"
      class="col-span-2 h-[50px] px-4 border border-gray-200 rounded-[8px] placeholder-gray-500 focus:border-primary-500 transition-colors outline-none"
      v-model="localValue.country"
      :country="localValue.country"
      :white-list="['BE']"
    ></country-select>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Emit, Watch } from "vue-facing-decorator";
  @Component({
    components: {
      FormInput: () => import("./input.vue"),
    },
  })
  export default class FormAddress extends Vue {
    @Prop() name?: string;

    @Prop() value?: Address;

    @Prop({ default: false }) disabled!: boolean;

    localValue: Address = {
      street: "",
      number: "",
      additional: "",
      city: "",
      zip: "",
      country: "",
    };

    @Emit("input")
    private handleInput() {
      return this.localValue;
    }

    @Watch("value", { immediate: true })
    private valueChanged(newValue: Address) {
      this.localValue = newValue;
    }
  }
</script>
